import { NotificationZone as Component } from './NotificationZone';
import { mapStateToPropsNotificationZone } from './connect';
import { connect } from 'react-redux';
import { selectors } from 'state/selectors';

export const NotificationZone = connect(mapStateToPropsNotificationZone(selectors))(Component);
